import React from 'react';
import {
    Select as UiSelect,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from '@components/ui/select';
import { cn } from '@core/utils/cn';
import { FieldError, FieldLabel } from '../textfield';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Option<T = any> {
    label: string;
    value: T;
    adornment?: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface SelectProps<T = any> {
    label: string;
    required?: boolean;
    value: T;
    error?: string;
    options: readonly Option<T>[];
    noLabel?: boolean;
    fullWidth?: boolean;
    disabled?: boolean;
    onChange(value: T): void;
}

export function Select(props: SelectProps) {
    const id = React.useId();
    const selectedIndex = props.options.findIndex(
        (option) => option.value === props.value
    );
    return (
        <div
            className={cn(
                'flex flex-col gap-1.5',
                props.fullWidth === false ? 'w-auto' : 'w-full'
            )}
        >
            {!props.noLabel && (
                <FieldLabel
                    htmlFor={id}
                    label={props.label}
                    required={props.required}
                />
            )}
            <UiSelect
                value={selectedIndex >= 0 ? String(selectedIndex) : ''}
                disabled={props.disabled}
                onValueChange={(index) =>
                    props.onChange(props.options[Number(index)].value)
                }
            >
                <SelectTrigger
                    id={id}
                    aria-invalid={Boolean(props.error)}
                    className="w-full"
                >
                    <SelectValue
                        placeholder={props.noLabel ? props.label : undefined}
                    />
                </SelectTrigger>
                <SelectContent>
                    {props.options.map((option, index) => (
                        <SelectItem key={index} value={String(index)}>
                            <span className="flex items-center gap-2">
                                {option.label}
                                {option.adornment}
                            </span>
                        </SelectItem>
                    ))}
                </SelectContent>
            </UiSelect>
            <FieldError error={props.error} />
        </div>
    );
}
